import React, { useEffect, useRef } from 'react';
import Select from 'react-select';

const OriginField = ({
  options,
  value,
  onChange,
  customFilterOption,
  onMenuOpen,
  menuPortalTarget,
  isOpen
}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    if (isOpen && selectRef.current) {
      selectRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div className="sf-field-content">
      <Select
        ref={selectRef}
        className="react-select-container react-select-no-container"
        classNamePrefix="react-select"
        styles={{
          control: (base) => ({
            ...base,
            border: '1px solid #e0e0e0',
            boxShadow: 'none',
            minHeight: '40px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            '&:hover': {
              borderColor: '#123550',
            },
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '0 12px',
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            color: '#1e293b',
            fontSize: '16px',
          }),
        }}
        onMenuOpen={onMenuOpen}
        value={value ? options.find(opt => opt.value === value) : null}
        onChange={(selected) => onChange(selected ? selected.value : null)}
        options={options}
        placeholder="Buscar país..."
        controlShouldRenderValue={true}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? `No se encontró "${inputValue}"` : "Escribe para buscar..."
        }
        isClearable={true}
        isSearchable
        blurInputOnSelect={false}
        filterOption={customFilterOption}
        autoFocus={isOpen}
        menuIsOpen={isOpen ? true : undefined}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
};

export default OriginField;
